<component v-if="isHtml" :is="tag" v-safe-html="valueLocal"></component><component v-else :is="tag">{{ valueLocal }}</component>